<template>
<div class="chapter">
<div class="inner_page">
<div class="cover" epub:type="cover">
<img alt="Cover image of Explorations in Asian Christianity" class="cover" src="Images/9780830890859.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01cover.vue?438eb5e4